import { BlocksIconCopy } from 'blocks-nextjs/blocks-web-components/components/icon/icons/copy';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCopy = createComponent({ react: React, tagName: 'cat-icon-copy', elementClass: BlocksIconCopy });
